import * as React from 'react';

function SvgArrowRandom(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width={24} height={24} viewBox="0 0 24 24" {...props}>
      <path d="M8.7 10a1 1 0 001.41 0 1 1 0 000-1.41l-6.27-6.3a1.004 1.004 0 00-1.42 1.42zM21 14a1 1 0 00-1 1v3.59L15.44 14A1.018 1.018 0 0014 15.44L18.59 20H15a1 1 0 100 2h6a1 1 0 00.38-.08 1 1 0 00.54-.54A1 1 0 0022 21v-6a1 1 0 00-1-1zm.92-11.38a1 1 0 00-.54-.54A1 1 0 0021 2h-6a1 1 0 100 2h3.59L2.29 20.29a1 1 0 00-.006 1.414l.006.006a1 1 0 001.414.006l.006-.006L20 5.41V9a1 1 0 102 0V3a1 1 0 00-.08-.38z" />
    </svg>
  );
}

export default SvgArrowRandom;
